var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.post ? _c('div', {
    staticClass: "post-details-page"
  }, [_c('divider', {
    attrs: {
      "label": "blog"
    }
  }), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "blog-details-hero"
  }, [_c('div', {
    staticClass: "asset-container"
  }, [_vm.post && _vm.post.details.featuredImage ? _c('img', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    attrs: {
      "src": _vm.post.details.featuredImage,
      "alt": "post featured image"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/defaultPostImage.png"),
      "alt": "Default Post Image"
    }
  })]), _vm._m(0)]), _c('div', {
    staticClass: "post-info-container"
  }, [_c('div', {
    staticClass: "post-info-wrapper"
  }, [_c('post-info', {
    attrs: {
      "post": _vm.post
    }
  })], 1), _c('div', {
    staticClass: "line-row"
  }, [_c('img', {
    staticClass: "line-arrow",
    attrs: {
      "src": require("../../assets/icons/arrow-black-left.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "line"
  }), _c('blog-social-links', {
    attrs: {
      "post": _vm.post
    }
  })], 1)]), _c('div', {
    staticClass: "line-separator"
  }), _c('div', {
    staticClass: "post-container"
  }, [_vm.post ? _c('post-details', {
    attrs: {
      "post": _vm.post
    }
  }) : _vm._e(), _c('div', {
    staticClass: "related-blog-posts-section"
  }, [_c('div', {
    staticClass: "text-row heading-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('blog.blog_name', {
        blog: 'blog'
      }))
    }
  }), _vm.relatedPosts && _vm.relatedPosts.length > 0 ? _c('div', {
    staticClass: "heading-3-regular"
  }, [_vm._v(" " + _vm._s(_vm.$t('blog.related_articles')) + ": ")]) : _vm._e(), _vm._l(_vm.relatedPosts, function (post) {
    return _c('post-grid-card', {
      key: post.id,
      attrs: {
        "post": post
      },
      on: {
        "viewPost": _vm.openPostDetailsPage
      }
    });
  })], 2)], 1)])], 1) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "logo-box"
  }, [_c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo/seu-logo-name.svg"),
      "alt": ""
    }
  })])])]);

}]

export { render, staticRenderFns }